import { observer } from 'mobx-react';
import { useState } from "react";
import { LogoLoader } from '../../../../common/components/LogoLoader/LogoLoader';
import { useStore } from "../../../app/data/root.store";
import { VaultDownIcon, VaultFilesEmptyStateLastSkeletonIcon, VaultFilesEmptyStateSkeletonIcon } from "../../assets/icons";
import { SORT_BY_OPTIONS } from '../../data/vault-store';
import { VaultEmptyState } from '../VaultEmptyState/VaultEmptyState';
import { VaultListItem } from "../VaultListItem/VaultListItem";
import { VaultSortDropdown } from "../VaultSortDropdown/VaultSortDropdown";
import { VaultItemSelectedCheckboxWrapper, VaultListHeader, VaultListHeaderSortButton, VaultListHeaderSortDirectionButton, VaultListItemsWrapper, VaultListWrapper } from "./VaultList.styles";
import { VaultListFooter } from "./VaultListFooter";

import { colors } from '../../../../common/styles/theme.styles';
import { ItemSelectedCheckbox } from '../../../wealth/pages/class/components/ClassPage.styles';

const ItemSelectedIcon = () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
        <path d="m7 2-4 4L1 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const VaultList = observer(() => {
    const { vaultStore } = useStore();
    const [isSortDropdownOpen, setIsSortDropdownOpen] = useState(false);

    const handleSelectAllCheckboxClick = () => vaultStore.bulkEditToggleSelectAllFiles();
    const { isLoading, filesByPage, meta, hasActiveFilters, isAllFilesSelectedForBulkEdit, isPartialFilesSelectedForBulkEdit, isBulkEditMode, sortBy, sortDirection } = vaultStore;
    const hasFiles = filesByPage.length > 0;
    const isEmptyState = !isLoading && !hasFiles;

    if (isLoading && !hasFiles) {
        return (
            <div style={{ width: '100%' }}>
                <LogoLoader />
            </div>
        );
    }

    return (
        <VaultListWrapper data-testid="vault-list-wrapper">
            {
                isEmptyState ? (
                    hasActiveFilters ? <VaultEmptyState /> : (
                        <VaultListItemsWrapper isEmptyState>
                            <VaultFilesEmptyStateSkeletonIcon style={{ width: '100%' }} />
                            <VaultFilesEmptyStateSkeletonIcon style={{ width: '100%' }} />
                            <VaultFilesEmptyStateLastSkeletonIcon style={{ width: '100%' }} />
                        </VaultListItemsWrapper>
                    )
                ) :
                    <>
                        <VaultListHeader>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <VaultItemSelectedCheckboxWrapper
                                    onClick={handleSelectAllCheckboxClick}
                                    isSelected={isAllFilesSelectedForBulkEdit}
                                    isHeaderItem
                                    isBulkEditMode={isBulkEditMode}
                                >
                                    <ItemSelectedCheckbox
                                        isSelected={isAllFilesSelectedForBulkEdit}
                                        isPartialSelected={isPartialFilesSelectedForBulkEdit}
                                    >
                                        {isAllFilesSelectedForBulkEdit && <ItemSelectedIcon />}
                                        {isPartialFilesSelectedForBulkEdit && (
                                            <div style={{
                                                width: '4px',
                                                height: '1px',
                                                marginTop: '1px',
                                                backgroundColor: colors.darkGray1
                                            }} />
                                        )}
                                    </ItemSelectedCheckbox>
                                </VaultItemSelectedCheckboxWrapper>
                                {`Name (${filesByPage.length})`}
                            </div>
                            <VaultListHeaderSortButton onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}>
                                <div>{SORT_BY_OPTIONS[sortBy].label}</div>
                                <VaultListHeaderSortDirectionButton
                                    sortDirection={sortDirection}
                                    onClick={() => vaultStore.setSortDirection(-vaultStore.sortDirection)}
                                >
                                    <VaultDownIcon />
                                </VaultListHeaderSortDirectionButton>
                            </VaultListHeaderSortButton>
                            {isSortDropdownOpen && <VaultSortDropdown onClose={() => setIsSortDropdownOpen(false)} />}
                        </VaultListHeader>
                        <VaultListItemsWrapper>
                            {filesByPage.map((item, index) => (<VaultListItem key={index} file={item} />))}
                        </VaultListItemsWrapper>
                        {(meta.totalPages > 1) && <VaultListFooter />}
                    </>
            }
        </VaultListWrapper>
    );
});